export const checkContractOptionCanDoSpecialDestination = (
  contracts,
  userProfiles,
  fieldName
) => {
  let canContractOptionsDoSpecialDestination = false;

  for (let contract of contracts) {
    for (let profile of userProfiles?.data) {
      if (
        profile[fieldName] === contract &&
        profile?.profileCod?.includes("DEST_ESPECIAL")
      ) {
        canContractOptionsDoSpecialDestination = true;
      }
    }
  }
  return canContractOptionsDoSpecialDestination;
};
